export const BANNER_COOKIE_VALUE = 'hide'

export const getExpireTime = () => {
  return new Date(Date.now() + 1000 * 60 * 60 * 24) // 1 day
}
